<script setup>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';
import {useForm} from '@inertiajs/vue3';
import {inject, ref} from 'vue';
import TeamMemberTable from '@/Pages/Dashboard/Account/Partials/Teams/TeamMemberTable.vue';
import TeamInvitationsTable from '@/Pages/Dashboard/Account/Partials/Teams/TeamInvitationsTable.vue';
import TeamInviteForm from '@/Pages/Dashboard/Account/Partials/Teams/TeamInviteForm.vue';

const trans = inject('trans');

defineProps({
  permissions: {
    type: Array,
    required: true,
  },
  teamMembers: {
    type: Array,
    required: true,
  },
  teamInvitations: {
    type: Array,
    required: true,
  },
});

const form = useForm({
  email: null,
  permissions: [],
});

const successMessage = ref(null);
const showSuccess = ref(false);

const handleFormSubmitted = () => {
  successMessage.value = trans('dashboard.account.teams.messages.success_invite_team_member');
  showSuccess.value = true;
};

const handleRevoke = invitation => {
  form.delete(route('dashboard.account.teams.invitation-revoke', {invitation: invitation.id}), {
    onSuccess: () => {
      successMessage.value = trans('dashboard.account.teams.messages.success_revoke_team_member_invitation');
      showSuccess.value = true;
    },
  });
};

const handleResend = invitation => {
  form.post(route('dashboard.account.teams.invitation-resend', invitation), {
    onSuccess: () => {
      successMessage.value = trans('dashboard.account.teams.messages.success_resend_team_member_invitation');
      showSuccess.value = true;
    },
  });
};

const handleUpdated = () => {
  successMessage.value = trans('dashboard.account.teams.messages.success_update_team_member');
  showSuccess.value = true;
};

const handleDeletedTeamMember = () => {
  successMessage.value = trans('dashboard.account.teams.messages.success_delete_team_member');
  showSuccess.value = true;
};
</script>

<template>
  <dashboard-layout>
    <div class="tile my-4">
      <div class="card-body">
        <h3 class="h5">{{ trans('dashboard.account.teams.settings.title') }}</h3>
        <div v-if="showSuccess && successMessage" class="alert alert-success">
          {{ successMessage }}
        </div>

        <team-invite-form v-if="$can('teams.invite')" :permissions="permissions" @submitted="handleFormSubmitted"/>

        <div class="">
          <h3 class="h5">{{ trans('dashboard.account.teams.invitations.title') }}</h3>
          <div>
            <team-invitations-table
              :team-invitations="teamInvitations"
              @revoke="handleRevoke"
              @resend="handleResend"
            ></team-invitations-table>
          </div>
        </div>

        <div class="">
          <h3 class="h5">{{ trans('dashboard.account.teams.members.title') }}</h3>
          <div>
            <team-member-table
              :team-members="teamMembers"
              :permissions="permissions"
              @updated="handleUpdated"
              @deleted="handleDeletedTeamMember"
            />
          </div>
        </div>
      </div>
    </div>
  </dashboard-layout>
</template>
